import { StaffDTO } from '../../src/types';

const validStaff: StaffDTO = {
  id: '123-456',
  fullName: 'staff0',
  image: null,
};

export default function StaffBuilder() {
  const staffDTO = { ...validStaff };

  return {
    build: () => staffDTO,
    buildWithName(name: string) {
      staffDTO.fullName = name;
      return this;
    },
  };
}
